import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeFilterOperatorDlv,
  reportFilterOperatorDlvSelector,
  reportOperatorDlvOptionsSelector,
} from '../../../state';
import { MultiSelect } from '../../selects';

const OperatorDlvFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const operatorDlvOptionsResource = useSelector(reportOperatorDlvOptionsSelector);
  const operatorDlv = useSelector(reportFilterOperatorDlvSelector);
  const disabled = !operatorDlvOptionsResource.loaded;
  const operatorDlvOptions = operatorDlvOptionsResource.data || [];

  const handleChange = useCallback(
    (value: string[]) => dispatch(changeFilterOperatorDlv(value)),
    [dispatch]
  );

  return (
    <MultiSelect
      label={t('toolbar.labels.operatorDlv')}
      options={operatorDlvOptions}
      disabled={disabled}
      value={operatorDlv}
      onChange={handleChange}
      loading={operatorDlvOptionsResource.loading}
    />
  );
};

export default OperatorDlvFilter;
